import { useEffect, useState } from "react";
import api from "../../../Component/axios";

export const useDestinoInmediato = () => {
  const [destinoInmediato, setDestinoInmediato] = useState([]);

  const getDestinoInmediato = async () => {
    try {
      const response = await api.get("api/empaque/destino-inmediato");
      setDestinoInmediato(response.data);
    } catch (error) {
      setDestinoInmediato([]);
      console.log(error);
    }
  };

  useEffect(() => {
    getDestinoInmediato();
  }, []);

  return { destinoInmediato };
};
